
import Vue from 'vue'

export default Vue.extend({
   name: 'OrderTypeSummary',
   data() {
      return {
         step: 'order_type',
      }
   },
   computed: {
      visible(): boolean {
         return (
            this.$store.state.step !== this.step &&
            this.$store.state.viewedSteps.includes(this.step)
         )
      },
      orderType(): string {
         if (this.isPersonalOrder) {
            return 'Personal Order'
         }
         if (!!this.schoolName) {
            return `School Order for ${this.schoolName}`
         }
         return 'School Order'
      },
      isPersonalOrder(): boolean {
         return this.$store.state.purchase.IsPersonalOrder
      },
      schoolName(): string {
         return this.$store.getters.schoolName
      },
   },
   methods: {
      change() {
         this.$store.commit('setStep', this.step)
      },
   },
})
